import { useParams } from 'react-router-dom';

import { FormSubmitButton } from '../../components/Button/PrimaryButton';
import { FormComponent } from '../../components/FormCom/FormComponent';
import { HideableTextFormField } from '../../components/FormCom/HideableTextFormField';
import useAuth from '../../hooks/useAuth';
import {
  ISignupData,
  SignUpDataType,
  signUpInitialValues,
  SignUpSchema,
} from '../../models/auth/signUp.model';

export const SignUpArea = () => {
  const { base64Secret } = useParams();
  const { loading, signupUser } = useAuth();

  const onSubmit = async (values: SignUpDataType) => {
    const sigupnData: ISignupData = {
      base64Secret,
      password: values.password,
    };
    signupUser(sigupnData);
  };

  return (
    <FormComponent
      initialValues={signUpInitialValues}
      schema={SignUpSchema}
      onSubmit={onSubmit}
    >
      <HideableTextFormField
        label="Password"
        name="password"
        type="password"
        placeholder="Password"
      />

      <FormSubmitButton className="spanTwo" type="submit" showIcon={loading}>
        Sign In
      </FormSubmitButton>
    </FormComponent>
  );
};
